"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOSED_SET_FIELDS = exports.FIELDS = exports.CC_STATE_MAP = exports.STATE_ABBREVIATION_MAP = exports.COUNTRIES_WITH_NO_REQUIRED_STATES = exports.COUNTRIES_WITH_REQUIRED_STATES = exports.FIELD_VALUE_MAP = exports.YesNoOption = exports.PATTERNS = void 0;

var _challenge = _interopRequireDefault(require("./values/challenge"));

var _geo_region_source = _interopRequireDefault(require("./values/geo_region_source"));

var _number_of_employees_at_location = _interopRequireDefault(require("./values/number_of_employees_at_location"));

var _number_of_employees_global = _interopRequireDefault(require("./values/number_of_employees_global"));

var _number_of_servers_project = _interopRequireDefault(require("./values/number_of_servers_project"));

var _preferred_language = _interopRequireDefault(require("./values/preferred_language"));

var _prospect_type = _interopRequireDefault(require("./values/prospect_type"));

var _processing_type = _interopRequireDefault(require("./values/processing_type"));

var _purchase_timeframe = _interopRequireDefault(require("./values/purchase_timeframe"));

var _utm_medium = _interopRequireDefault(require("./values/utm_medium"));

var _department = _interopRequireDefault(require("./values/department"));

var _industry = _interopRequireDefault(require("./values/industry"));

var _product = _interopRequireDefault(require("./values/product"));

var _salutation = _interopRequireDefault(require("./values/salutation"));

var _title = _interopRequireDefault(require("./values/title"));

var _Patterns = _interopRequireDefault(require("../Patterns"));

var _if_project_do_you_have_budget = _interopRequireDefault(require("./values/if_project_do_you_have_budget"));

var _country = _interopRequireDefault(require("./values/country"));

var _states_US = require("./values/states_US");

var _states_CA = require("./values/states_CA");

var _states_CN = _interopRequireDefault(require("./values/states_CN"));

var _states_AU = require("./values/states_AU");

var _states_IN = _interopRequireDefault(require("./values/states_IN"));

var _field_names = require("./values/field_names");

var _states_US_map = _interopRequireDefault(require("./values/states_US_map"));

var _states_AU_map = _interopRequireDefault(require("./values/states_AU_map"));

var _states_CA_map = _interopRequireDefault(require("./values/states_CA_map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** closed set field values **/

/** state/country **/

/** field names **/

/** reverse country abbreviation maps **/

/** exporting patterns **/
var PATTERNS = _Patterns.default;
exports.PATTERNS = PATTERNS;
var YesNoOption = ["Yes", "No"];
/** closed set field mappings **/

exports.YesNoOption = YesNoOption;

var FIELD_VALUE_MAP = function FIELD_VALUE_MAP() {
  var mkto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "legacy";
  var legacy = {
    'Department': _department.default,
    // department
    'industry': _industry.default,
    // Industry_Self_Reported__c
    'PrimaryProductInterest': _product.default,
    // Primary_Product_Interest__c
    'salutation': _salutation.default,
    'title': _title.default,
    'fields': _field_names.legacy,
    //
    'Challenge': _challenge.default,
    // Challenge__c
    'GEORegionSource': _geo_region_source.default,
    // removed in 1MKTO
    'IfProjectdoyouhaveBudget': _if_project_do_you_have_budget.default,
    // Project_Budget__c
    'Hot_HaveSalesCallME': YesNoOption,
    // Sales_Contact_Requested__c
    'MailOk': YesNoOption,
    // Direct_Mail_OK__c
    'PhoneOk': YesNoOption,
    // OK_to_Call__c
    'NumberofEmployees-here/atlocation': _number_of_employees_at_location.default,
    // removed in 1MKTO
    'NumberofEmployees-Global': _number_of_employees_global.default,
    // NumberOfEmployees_Self_Reported__c
    'NumberofServersProject': _number_of_servers_project.default,
    // removed in 1MKTO
    'PreferredLanguage': _preferred_language.default,
    // Preferred_Language__c
    'PurchaseTimeframe': _purchase_timeframe.default,
    // Purchase_Timeframe__c
    'ProspectType': _prospect_type.default,
    // removed in 1MKTO
    'VirtualizationInitiative': YesNoOption,
    // removed in 1MKTO
    'UTMMedium': _utm_medium.default,
    // UTM_Medium__c
    'ctx_RecordProcessingType': _processing_type.default,
    'country': _country.default,
    'state_au': _states_AU.wizard,
    'state_ca': _states_CA.wizard,
    'state_cn': _states_CN.default,
    'state_in': _states_IN.default,
    'state_us': _states_US.wizard,
    'marketingSuspended': PATTERNS.TRUE_OR_FALSE
  };
  var oneMkto = {
    'department': _department.default,
    // department
    'Industry_Self_Reported__c': _industry.default,
    // Industry_Self_Reported__c
    'Primary_Product_Interest__c': _product.default,
    // Primary_Product_Interest__c
    'salutation': _salutation.default,
    'Job_Title__c': _title.default,
    'fields': _field_names.one_mkto,
    //
    'Challenge__c': _challenge.default,
    // Challenge__c
    'Project_Budget__c': _if_project_do_you_have_budget.default,
    // Project_Budget__c
    'Sales_Contact_Requested__c': YesNoOption,
    // Sales_Contact_Requested__c
    'Direct_Mail_OK__c': YesNoOption,
    // Direct_Mail_OK__c
    'OK_to_Call__c': YesNoOption,
    // OK_to_Call__c
    'NumberOfEmployees_Self_Reported__c': _number_of_employees_global.default,
    // NumberOfEmployees_Self_Reported__c
    'Preferred_Language__c': _preferred_language.default,
    // Preferred_Language__c
    'Purchase_Timeframe__c': _purchase_timeframe.default,
    // Purchase_Timeframe__c
    'UTM_Medium__c': _utm_medium.default,
    // UTM_Medium__c
    'Record_Processing_Type__c': _processing_type.default,
    'country': _country.default,
    'state_au': _states_AU.wizard,
    'state_ca': _states_CA.wizard,
    'state_cn': _states_CN.default,
    'state_in': _states_IN.default,
    'state_us': _states_US.wizard
  };
  return mkto === "legacy" ? legacy : oneMkto;
};
/** countries with required state values **/


exports.FIELD_VALUE_MAP = FIELD_VALUE_MAP;
var COUNTRIES_WITH_REQUIRED_STATES = ['Australia', 'Canada', 'China', 'India', 'USA'];
/** countries which don't require state, no state mappings **/

exports.COUNTRIES_WITH_REQUIRED_STATES = COUNTRIES_WITH_REQUIRED_STATES;

var COUNTRIES_WITH_NO_REQUIRED_STATES = _country.default.filter(function (cc) {
  return !COUNTRIES_WITH_REQUIRED_STATES.includes(cc);
});
/** state abbreviation maps **/


exports.COUNTRIES_WITH_NO_REQUIRED_STATES = COUNTRIES_WITH_NO_REQUIRED_STATES;
var STATE_ABBREVIATION_MAP = {
  us: _states_US_map.default,
  au: _states_AU_map.default,
  ca: _states_CA_map.default
  /** country to state map **/

};
exports.STATE_ABBREVIATION_MAP = STATE_ABBREVIATION_MAP;
var CC_STATE_MAP = {
  "USA": _states_US.validator,
  "Canada": _states_CA.validator //"China": states_CN,
  //"India": states_IN,
  //"Australia": states_AU_validator,

  /** handle to all fields **/

};
exports.CC_STATE_MAP = CC_STATE_MAP;

var FIELDS = function FIELDS() {
  var mkto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "legacy";
  return mkto === "legacy" ? _field_names.legacy : _field_names.one_mkto;
};
/** fields with closed set values **/
//TODO refactor


exports.FIELDS = FIELDS;

var CLOSED_SET_FIELDS = function CLOSED_SET_FIELDS() {
  var mkto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "legacy";
  var legacy = ['reason', 'Department', 'industry', 'PrimaryProductInterest', 'salutation', 'title', 'Challenge', 'GEORegionSource', 'IfProjectdoyouhaveBudget', 'Hot_HaveSalesCallME', 'MailOk', 'country', 'state', //TODO, this is needed here for Wizard, but not for Validator, validator will trim it from it's version
  'EmailOk', 'PhoneOk', 'NumberofEmployees-here/atlocation', 'NumberofEmployees-Global', 'NumberofServersProject', 'PreferredLanguage', 'PurchaseTimeframe', 'ProspectType', 'VirtualizationInitiative', 'UTMMedium', 'ctx_RecordProcessingType'];
  var oneMkto = ['reason', 'department', 'Industry_Self_Reported__c', 'Primary_Product_Interest__c', 'salutation', 'Job_Title__c', 'Challenge__c', 'Project_Budget__c', 'Sales_Contact_Requested__c', 'Direct_Mail_OK__c', 'country', 'state', //TODO, this is needed here for Wizard, but not for Validator, validator will trim it from it's version
  'EmailOk', 'OK_to_Call__c', 'NumberOfEmployees_Self_Reported__c', 'Preferred_Language__c', 'Purchase_Timeframe__c', 'UTM_Medium__c', 'Record_Processing_Type__c'];
  return mkto === "legacy" ? legacy : oneMkto;
};

exports.CLOSED_SET_FIELDS = CLOSED_SET_FIELDS;
//# sourceMappingURL=FIELD_CONSTANTS.js.map